;(function(factory) {
    // conditional factory logic should be placed here.
    if (typeof Lum == 'undefined' || typeof jQuery == 'undefined') {
        var lmnInterval = setInterval(function(){
            if (typeof Lum != 'undefined' && typeof jQuery != 'undefined') {
                clearInterval(lmnInterval);
                factory(jQuery);
            }
        }, 100);
    } else {
        factory(jQuery);
    }
})(function($) {

    var defaultOptions = {
        dateFormat: 'mm/dd/yy',
        onSelect: function(dateText) {
            if (typeof $(this).parsley != 'undefined') {
                // console.log($(this).mask());
                $(this).parsley().validate();
            }
        }
    };

    /**
     * Loads jQuery UI
     * 
     * @param  {Function} callback The callback to execute once the mask is loaded.
     * 
     * @return {Void}
     */
    function includeJQueryUI(callback) {
        if (typeof $("").datepicker != 'undefined') {
            return;
        }

        // var jsCDNUrl = 'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js';
        var styleCDNUrl = 'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.css';

        Lum.loadStyle(styleCDNUrl);
        // Lum.loadScriptAsync(jsCDNUrl, callback);
    }

    /**
     * This method creates the datepicker to a given element.
     * 
     * @param  {String} elementSelector The element selector: #elem-id or .elem-class
     * @param  {String} options         The options for the datepicker: Info: https://api.jqueryui.com/datepicker/
     * 
     * @return {Void}
     */
    var datepicker = function(elementSelector, options) {
        if (typeof options != "undefined") {
            options = {};
        }

        $options = $.extend(defaultOptions, options);

        $(elementSelector).datepicker(options);
    };
    
    var uiTooltip = function(selector, configObj) {
        if (!Lum.checkFunction($(selector).uitooltip)) {
            return setTimeout(function(){
                uiTooltip(selector, configObj);
            }, 100);
        }

        $(selector).uitooltip(configObj);
    };

    var parseMask = function (mask) {
        if (mask.indexOf("yyyy") != -1) {
            mask = mask.replace(/yyyy/, "yy");
        } else if (mask.indexOf("yy") != -1) {
            mask = mask.replace(/yy/, "y");
        }

        return mask;
    };

    var initDatePickers = function () {
        $(".lumina-date").each(function(ind, elem) {
            var dateFormat = $(elem).data('mask-format');

            if (dateFormat) {
                defaultOptions.dateFormat = parseMask(dateFormat);
            }

            $(elem).datepicker(defaultOptions);
        });

        $(".lumina-date-mmdd").each(function(ind, elem) {
            var dateFormat = $(elem).data('mask-format');

            // they used the mask format not the datepicker so it has 99/99/9999 in it.
            if (typeof dateFormat != 'undefined') {
                dateFormat = false;
            }

            if (dateFormat) {
                defaultOptions.dateFormat = parseMask(dateFormat);
            } else {
                defaultOptions.dateFormat = "mm/dd"; 
            }

            $(elem).datepicker(defaultOptions);
        });
    };

    /**
     * Keep the file versioned.
     * @return {String}
     */
    var version = function () {
        return '1.0.2';
    };

    window.Lum.DatePicker = {
        apply: datepicker,
        version: version
    };

    window.Lum.Tooltips = {
        uiTooltip: uiTooltip
    };

    window.Lum.datepicker = datepicker;

    includeJQueryUI(initDatePickers);
});
